import * as React from 'react';
import classNames from 'classnames';

import FormError from 'src/components/Form/FormError';

import IMPComponent from '../../../components/interfaces/IMPComponent';
import { FormattedMessage } from 'react-intl';

interface IAuthFormErrorsProps extends IMPComponent {
  errors?: string[];
}

const AuthFormErrors: React.FunctionComponent<IAuthFormErrorsProps> = ({ className, style, errors = [] }) => {
  const cn = classNames('AuthForm-errors', className);

  return (
    <ul className={cn} style={style}>
      {errors.map(error => {
        return (
          <li className="AuthForm-errorsItem" key={error}>
            <FormError>
              <FormattedMessage id={`errors.${error}`} />
            </FormError>
          </li>
        );
      })}
    </ul>
  );
};

export default React.memo(AuthFormErrors);



// WEBPACK FOOTER //
// ./src/containers/Auth/AuthForm/AuthFormErrors.tsx